import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { AuthGuard } from '@/components/auth/AuthGuard';
import { Layout } from '@/components/layout/Layout';
import { Dashboard } from '@/pages/Dashboard';
import { Pipeline } from '@/pages/Pipeline';
import { Prospects } from '@/pages/Prospects';
import { Import } from '@/pages/Import';
import { Benchmarking } from '@/pages/Benchmarking';
import { Admin } from '@/pages/Admin';
import { PasswordResetPage } from '@/components/auth/PasswordResetPage';
import { Toaster } from '@/components/ui/sonner';

function PasswordResetRoute() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <PasswordResetPage 
      token={token} 
      onComplete={() => window.location.href = '/'} 
    />
  );
}

function AuthenticatedApp() {
  return (
    <AuthGuard>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/prospects" element={<Prospects />} />
          <Route path="/import" element={<Import />} />
          <Route path="/benchmarking" element={<Benchmarking />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Layout>
    </AuthGuard>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/reset-password" element={<PasswordResetRoute />} />
        <Route path="/*" element={<AuthenticatedApp />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
